import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';
import Loader from 'components/loader/loader';
import RichTextViewer from 'components/rich-text-viewer/rich-text-viewer';
export const QuestionAnswerFillBlanks = ({ question }) => {
    var _a, _b, _c, _d;
    const [loading, setLoading] = useState(true);
    const [alteredContent, setAlteredContent] = useState();
    const questionContent = JSON.parse((_a = question.questionContent) !== null && _a !== void 0 ? _a : '{}');
    const evaluationContent = JSON.parse((_b = question.evaluationContent) !== null && _b !== void 0 ? _b : '{}');
    let { userAnswer } = JSON.parse((_d = (_c = question === null || question === void 0 ? void 0 : question.questionAnswer) === null || _c === void 0 ? void 0 : _c.rawAnswer) !== null && _d !== void 0 ? _d : '{}');
    userAnswer = userAnswer === undefined ? [] : userAnswer;
    useEffect(() => {
        if (!question) {
            return;
        }
        setLoading(true);
        let content = evaluationContent.content;
        const blanks = questionContent.blanks;
        blanks.forEach((blank) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const answered = (userAnswer !== null && userAnswer !== void 0 ? userAnswer : []).find((item) => item.id === blank.id);
            let isCorrect = false;
            let correctAnswer = '';
            if (blank.type === 'text') {
                switch (blank.matchingType) {
                    case 'matchCase': {
                        const normalizedBlankAnswer = ((_a = blank.answer) !== null && _a !== void 0 ? _a : '')
                            .normalize('NFD')
                            .replace(/\p{Diacritic}/gu, '')
                            .toLowerCase();
                        const normalizedUserAnswer = ((_b = answered === null || answered === void 0 ? void 0 : answered.answer) !== null && _b !== void 0 ? _b : '')
                            .normalize('NFD')
                            .replace(/\p{Diacritic}/gu, '')
                            .toLowerCase();
                        if (normalizedBlankAnswer === normalizedUserAnswer) {
                            isCorrect = true;
                        }
                        break;
                    }
                    case 'matchExact':
                        if (blank.answer === ((_c = answered === null || answered === void 0 ? void 0 : answered.answer) !== null && _c !== void 0 ? _c : '')) {
                            isCorrect = true;
                        }
                        break;
                    default:
                        break;
                }
                correctAnswer = (_d = blank.answer) !== null && _d !== void 0 ? _d : '';
            }
            if (blank.type === 'select') {
                const temp = (_e = blank.options) === null || _e === void 0 ? void 0 : _e.filter(option => option.isCorrect);
                const blankCorrects = temp === null || temp === void 0 ? void 0 : temp.map(option => option.text.toLowerCase());
                if (blankCorrects === null || blankCorrects === void 0 ? void 0 : blankCorrects.includes((_f = answered === null || answered === void 0 ? void 0 : answered.answer) !== null && _f !== void 0 ? _f : '')) {
                    isCorrect = true;
                }
                correctAnswer = (_h = (_g = temp === null || temp === void 0 ? void 0 : temp.shift()) === null || _g === void 0 ? void 0 : _g.text) !== null && _h !== void 0 ? _h : '';
            }
            const input = (_jsxs("label", Object.assign({ className: `fill-in-blank-container ${isCorrect ? 'fill-in-blank-container--success' : 'fill-in-blank-container--danger'}` }, { children: [!isCorrect && (_jsxs("span", Object.assign({ className: "helper-message__text" }, { children: [_jsx("i", { className: "fas fa-check helper-icon" }, void 0), _jsx("span", { children: correctAnswer }, void 0)] }), void 0)), _jsx("input", { id: `blank_${blank.id}`, className: "input--fill-in-blank", type: "text", value: (_j = answered === null || answered === void 0 ? void 0 : answered.answer) !== null && _j !== void 0 ? _j : '', style: { width: `${(_k = blank.width) !== null && _k !== void 0 ? _k : '100px'}` }, readOnly: true, disabled: true }, `blank_${blank.id}`)] }), void 0));
            const textInput = renderToString(input);
            content = content.replace(`%BLANK_${blank.id}%`, textInput);
        });
        setAlteredContent(content);
    }, [question]);
    useEffect(() => {
        setLoading(false);
    }, [alteredContent]);
    const iFrameInitialContent = `
    <!DOCTYPE html>
    <html>
      <head>
      <link type="text/css" rel="stylesheet" href="https://cdn.tiny.cloud/1/kdsi0dycn4pq62nxenf4zbb3iqayj68ly6zxpt7czz5lb33p/tinymce/6.1.2-8/skins/ui/oxide/content.min.css" crossorigin="anonymous">
      <link type="text/css" rel="stylesheet" href="https://cdn.tiny.cloud/1/kdsi0dycn4pq62nxenf4zbb3iqayj68ly6zxpt7czz5lb33p/tinymce/6.1.2-8/skins/content/default/content.min.css" crossorigin="anonymous">
      <script src=“https://kit.fontawesome.com/d855224b6a.js” crossorigin=“anonymous”></script>
      <base target="_blank">

      <style>
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;400;500;600;700;800&display=swap');

        .preview__text {
          display: block;
          background: #f6f8ff;
          padding: 32px;
          line-height: 2.5;
          margin: 16px 0px 40px;
          text-align: justify !important;
        }

        .input--fill-in-blank, .select--fill-in-blank {
          display: inline;
          min-width: 100px;
          width: 100px;
          height: 27px;
          margin: 0px;
          border: none;
          color: #1b1c23;
          border-bottom: 2px dashed #1b1c23;
          border-radius: 4px;
          box-sizing: border-box;
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          font-family: "Montserrat", serif;
        }
        
        .select--fill-in-blank {
          padding: 0px 16px;
          height: 32px;
          width: auto;
        }

        .preview__text--review {
          line-height: 3;
        }
        .preview__text--review .fill-in-blank-container {
          position: relative;
        }
        .preview__text--review .fill-in-blank-container .helper-text {
          position: absolute;
          font-size: 12px;
          color: #1b1c23;
          bottom: -32px;
        }
        .preview__text--review .fill-in-blank-container .helper-icon {
          font-size: 10px;
          color: #1b1c23;
          margin-right: 4px;
        }
        .preview__text--review .fill-in-blank-container.fill-in-blank-container--danger .helper-text {
          color: #1c7d44;
        }
        .preview__text--review .fill-in-blank-container.fill-in-blank-container--danger .helper-icon {
          color: #1c7d44;
        }
        .preview__text--review .fill-in-blank-container.fill-in-blank-container--danger input.input--fill-in-blank {
          border-bottom-color: #9e1542;
          color: #710f2f;
          background: #eed3da;
        }
        .preview__text--review .fill-in-blank-container.fill-in-blank-container--success .helper-text {
          color: #1c7d44;
        }
        .preview__text--review .fill-in-blank-container.fill-in-blank-container--success .helper-icon {
          color: #1c7d44;
        }
        .preview__text--review .fill-in-blank-container.fill-in-blank-container--success .input--fill-in-blank {
          border-bottom-color: #26a65b;
          color: #1c7d44;
          background: #e1ecec;
        }
      </style>
      </head>
      <body id="tinymce" class="mce-content-body">
        <div id="mountTarget" class="preview__text preview__text--review"></div>
      </body>
    </html>
  `;
    return (_jsxs("div", Object.assign({ className: "w-100 p-3" }, { children: [loading && (_jsx(Loader, {}, void 0)), !loading && (_jsx(RichTextViewer, { id: `question-${question.id}`, content: alteredContent !== null && alteredContent !== void 0 ? alteredContent : '', customInitialContent: iFrameInitialContent }, void 0))] }), void 0));
};
export default QuestionAnswerFillBlanks;
